import { useMemo } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import useExpectations from 'hooks/reports/utilization/package-utilization/useExpectations';
import type { PackageUtilizationExpectationListItem } from 'types';

function useFilteredExpectations(
  search: string,
  wait: number = 200,
): {
  data: PackageUtilizationExpectationListItem[];
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
} {
  const { data, ...rest } = useExpectations({});
  const [debouncedSearch] = useDebouncedValue(search, wait);

  const filteredData = useMemo(() => {
    if (!data?.data || !debouncedSearch.trim()) {
      return data?.data ?? [];
    }

    return data.data.filter(item => item.package.name.toLowerCase().includes(debouncedSearch.toLowerCase()));
  }, [data?.data, debouncedSearch]);

  return { data: filteredData, ...rest };
}

export default useFilteredExpectations;
